@if (!companies || companies.length) {
  <section @fadeInOut>
    <div class="main vertical-container column-gap-1">
      @if (isAdmin) {
        <div class="space-between-flex-end">
          <div></div>
          <app-button
            [iconName]="'plus.svg'"
            [type]="'grey-accent'"
            [size]="'small'"
            (buttonClick)="show.companyCrud = true">
            Company
          </app-button>
        </div>
      }
      <div class="table-fms">
        <table>
          <thead>
          <tr>
            <th class="fix-w-2">
              @if (isAdmin) {
                <app-three-dots-menu data-qa="kpi-companies-three-dots" [matMenuTriggerFor]="menu"/>
              }
              <mat-menu #menu="matMenu">
                <ul data-qa="kpi-companies-three-dots-menu" class="list">
                  <app-drop-down-item
                    class="width-100pcnt"
                    data-qa="bulk-upload-companies"
                    [iconNameAndStyling]="'upload-arrow-in-rectangle.svg'"
                    [text]="'Bulk upload companies'"
                    (click)="show.companyBulkUpload = true">
                  </app-drop-down-item>
                  <app-drop-down-item
                    class="width-100pcnt"
                    data-qa="bulk-delete-companies"
                    [menuItemClass]="'red'"
                    [iconNameAndStyling]="'delete.svg; red-11'"
                    [text]="'Bulk delete'"
                    (click)="show.companyBulkDelete = true">
                  </app-drop-down-item>
                </ul>
              </mat-menu>
            </th>
            <th class="fix-w-2"></th>
            <th class="fix-w-13p75">Company</th>
            <th class="blank-space fix-w-0p25"></th>
            <th class="fix-w-13p75">Last submission</th>
            <th class="blank-space fix-w-0p25"></th>
            <th class="fix-w-7p5">Registration</th>
            <th class="fix-w-7p5">Industry</th>
            <th class="fix-w-100pcnt">Description</th>
          </tr>
          </thead>
          <tbody>
            @if (!companies) {
              <tr *ngFor="let i of [].constructor(10)"
                  app-table-empty-state
                  class="animation-wrapper"
                  [tdAmount]="8"
                  [blankSpaceIndices]="[2,4]">
              </tr>
            }
            @if (companies) {
              @for (group of grouping; track group) {
                <tr>
                  <td
                    [attr.data-qa]="'kpi-company-table-hide-unhide-grouping-' + grouping"
                    class="col-three-dots"
                    (click)="show.grouping[group].isShown = !show.grouping[group].isShown">
                    <app-table-group-icon
                      [attr.data-qa]="group + '-show-grouping'"
                      [opened]="show.grouping[group].isShown"
                    />
                  </td>
                  <td colspan="100%">
                    <div class="flex gap-[0.5rem] items-center">
                      <span [attr.data-qa]="group+'-grouping-name'"
                            class="bold500 font-4">
                        {{ group === 'tracked' ? 'Tracked' : 'Not tracked' }}
                      </span>
                      <span
                        [attr.data-qa]="'kpi-bulk-request-table-grouping-amount-' + show.grouping[group].amount"
                        class="caption-2 bold500 bg-black-4 br-0p5 padding-0p15625-0p3125">
                    {{ show.grouping[group].amount }}
                  </span>
                    </div>
                  </td>
                </tr>
                @for (wrapper of companies; track wrapper; let i = $index) {
                  @if ((wrapper.company.isKpiPortfolioTracked && group === 'tracked' && show.grouping.tracked.isShown)
                  || (!wrapper.company.isKpiPortfolioTracked && group === 'untracked' && show.grouping.untracked.isShown)) {
                    <tr>
                      <td>
                        @if (isAdmin) {
                          <app-three-dots-menu [matMenuTriggerFor]="menu"/>
                        }
                        <mat-menu #menu="matMenu">
                          <ul class="list">
                            <app-drop-down-item
                              data-qa="kpi-company-table-update-company-track-status"
                              class="width-100pcnt"
                              [text]="'Set '+ (wrapper.company.isKpiPortfolioTracked ? 'not ' : '') + 'tracked'"
                              [iconNameAndStyling]="(wrapper.company.isKpiPortfolioTracked ? 'crossed-' : '') + 'eye.svg'"
                              (click)="updateTrackStatus(wrapper, !wrapper.company.isKpiPortfolioTracked)">
                            </app-drop-down-item>
                            <app-drop-down-item
                              data-qa="kpi-company-table-edit-company"
                              class="width-100pcnt"
                              [iconNameAndStyling]="'edit.svg'"
                              [text]="'Edit'"
                              (click)="selected.company = wrapper.company; show.companyCrud = true">
                            </app-drop-down-item>
                            <app-drop-down-item
                              data-qa="kpi-company-table-add-company-member"
                              class="width-100pcnt"
                              [iconNameAndStyling]="'plus.svg'"
                              [text]="'Member'"
                              (click)="addCompanyMember(wrapper)">
                            </app-drop-down-item>
                            <app-drop-down-item
                              data-qa="kpi-company-table-delete-company"
                              class="width-100pcnt"
                              [menuItemClass]="'red'"
                              [iconNameAndStyling]="'delete.svg; red-11'"
                              [text]="'Delete'"
                              (click)="selected.company = wrapper.company; show.companyDeleteThinkTwice = true">
                            </app-drop-down-item>
                          </ul>
                        </mat-menu>
                      </td>
                      <td>
                        @if (wrapper.company.companyMembers.length) {
                          <app-table-group-icon
                            [attr.data-qa]="'company-open-' + wrapper.company.name"
                            [opened]="wrapper.isCompanyOpened"
                            (click)="wrapper.isCompanyOpened = !wrapper.isCompanyOpened"/>
                        }
                      </td>
                      <td>
                        <div class="flex items-center justify-between">
                          <div class="flex gap-[1rem]">
                            <div class="flex flex-col">
                              <span class="font-4 bold500">{{ wrapper.company.name }}</span>
                              <span *ngVar="wrapper.company.companyMembers.length as employeeAmount" class="caption-2">
                          {{ employeeAmount }} member{{ employeeAmount !== 1 ? 's' : '' }}
                        </span>
                            </div>
                          </div>
                          @if (wrapper.company.webSite) {
                            <app-all-icons
                              data-qa="company-website"
                              [iconNameAndStyling]="'planet.svg; clickable; icon-size-0p825'"
                              (click)="window.open(wrapper.company.webSite)"/>
                          }
                        </div>
                      </td>
                      <td class="blank-space"></td>
                      <td [attr.data-qa]="'last-submission-and-view-metrics-for-' + wrapper.company.name">
                        <div class="flex items-center justify-between">
                          <span>{{ wrapper.lastSubmission }}</span>
                          <app-button
                            data-qa="company-go-to-metrics"
                            [type]="'grey-outline'"
                            [size]="'xxxsmall'"
                            (buttonClick)="goToCompany(wrapper.company)">
                            View metrics
                          </app-button>
                        </div>
                      </td>
                      <td class="blank-space"></td>
                      <td>{{ wrapper.company.country }}</td>
                      <td>{{ wrapper.company.industry }}</td>
                      <td [id]="'description' + i" class="text-left"
                          (mouseenter)="fillTooltipData('description' + i, wrapper.company.description, MAX_DESC_LENGTH)"
                          (mouseleave)="deactivateTooltip()">
                        <span>{{ wrapper.company.description | linkShort : MAX_DESC_LENGTH }}</span>
                      </td>
                    </tr>
                    @if (wrapper.isCompanyOpened) {
                      <ng-container>
                        @for (member of wrapper.company.companyMembers; track member) {
                          <tr>
                            <td></td>
                            <td>
                              <div>
                                @if (isAdmin) {
                                  <app-three-dots-menu [matMenuTriggerFor]="menu"/>
                                }
                                <mat-menu #menu="matMenu">
                                  <ul class="list">
                                    <app-drop-down-item
                                      data-qa="update-company"
                                      class="width-100pcnt"
                                      [iconNameAndStyling]="'update.svg'"
                                      [text]="'Update member'"
                                      (click)="editCompanyMember(wrapper, member)">
                                    </app-drop-down-item>
                                  </ul>
                                </mat-menu>
                              </div>
                            </td>
                            <td>
                              <div class="flex gap-[1rem]">
                                <div class="flex flex-col items-start">
                                  <span class="font-4">{{ member.name }} {{ member.family }}</span>
                                  <span class="caption-2">{{ member.position }}</span>
                                </div>
                              </div>
                            </td>
                            <td class="blank-space"></td>
                            <td>{{ member.mail }}</td>
                            <td class="blank-space"></td>
                            <td>{{ member.phone }}</td>
                            <td colspan="2"></td>
                          </tr>
                        }
                      </ng-container>
                    }
                  }
                }
              }
            }
          </tbody>
        </table>
      </div>
    </div>
  </section>
}

@if (show.companyCrud) {
  <app-modal-company-crud
    [company]="selected.company"
    (companyCommonEmitter)="closeCompanyCrudModal(!!$event)"/>
}

@if (show.teamCrud) {
  <app-kpi-modal-company-member-crud
    [company]="selected.memberModalParams.company"
    [member]="selected.memberModalParams.member"
    [isDeleteEnabled]="selected.memberModalParams.isDeleteEnabled"
    (closeEmitter)="closeEmployeeModal($event)"/>
  />
}

@if (companies && !companies.length) {
  <div
    @fadeInOut2
    class="height-60vh">
    <app-empty-state-standard
      [isAdmin]="isAdmin"
      [heading]="'No companies yet'"
      [buttonText]="'Company'"
      [buttonIconName]="'plus.svg'"
      (buttonClick)="show.companyCrud = true"/>
  </div>
}

@if (tooltipSettings?.show) {
  <app-tooltip
    [coordinates]="tooltipSettings.coordinates"
    [title]="tooltipSettings.title"
  />
}

@if (show.companyBulkUpload) {
  <app-modal-company-bulk-upload-wrapper (closeEmitter)="closeCompanyBulkUpload($event)"/>
}

@if (show.companyBulkDelete) {
  <app-company-bulk-delete-modal (closeEmitter)="closeCompanyBulkDelete($event)"/>
}

@if (show.companyDeleteThinkTwice) {
  <app-modal-dialog
    [header]="'Delete company'"
    [showInput]="true"
    [addAdditionalText]="true"
    [mainText]="[selected.company.legalName ? selected.company.legalName : selected.company.name + ' will be deleted']"
    (isConfirmed)="closeDeleteCompanyModal($event)"
  />
}
